<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="返佣单列表" />
    </div>

    <div class="jc-page-content">
      <div class="jc-page-card">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <el-form
              class="jc-table-actionBar-item"
              :inline="true"
              :model="form"
            >
              <el-form-item>
                <el-alert
                  title="说明：待渠道商确认状态的返佣单，请您尽快在详情页中进行确认，确认通过后将进入结算流程；"
                  type="warning"
                  :closable="false"
                  show-icon
                >
                </el-alert>
              </el-form-item>

              <el-form-item>
                <el-button @click="exportList"
                  ><i class="jc-icon-download"></i>
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table :data="tableData" style="width: 100%" class="form-loading">
            <el-table-column label="单号">
              <template slot-scope="scope">{{
                scope.row.retrunBillId | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="生成时间">
              <template slot-scope="scope">{{
                scope.row.generateTimeStr | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="业务时间段" width="180px">
              <template slot-scope="scope">
                <span v-if="scope.row.billBeginStr">{{
                  `${scope.row.billBeginStr}至${scope.row.billEndStr}`
                }}</span>

                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column label="产品分类" width="100px">
              <template slot-scope="scope">{{
                scope.row.productTypeName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="金额(元)">
              <template slot-scope="scope">{{
                scope.row.returnMount | formatMoney
              }}</template>
            </el-table-column>

            <el-table-column label="返佣方式">
              <template slot-scope="scope">{{
                scope.row.returnModeName | filterParams
              }}</template>
            </el-table-column>

            <el-table-column label="状态">
              <template slot-scope="scope">
                <span
                  :class="[
                    scope.row.status === 30 || scope.row.status === 31
                      ? 'redColor'
                      : '',
                  ]"
                  >{{ scope.row.statusName | filterParams }}</span
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <router-link
                  :to="{
                    name: 'rebateDetail',
                    params: { id: scope.row.retrunBillId },
                  }"
                  >详情</router-link
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="jc-container-table-actionBar" v-if="total > 10">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="form.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryMyReturnBillList,
  exportMyReturnBillList,
} from '@/api/distributor-api.js'
// import { getDate } from '@/utils'
import routerMixins from '@/mixins/router-mixins.js'
import handlepageMixins from '@/mixins/handlepage-mixins.js'
export default {
  mixins: [routerMixins, handlepageMixins],
  data() {
    return {
      form: {
        pageSize: 10,
        pageIndex: 1,
        distributorId: '',
      },
      total: 0,
      tableData: [],
      queryFunction: queryMyReturnBillList,
      exportFunction: exportMyReturnBillList,
    }
  },
  activated() {
    this.query()
  },
  methods: {},
}
</script>

<style>
.redColor {
  color: red;
}
</style>
